// JourneyEndGate — app-level listener that shows the closing ceremony when
// the「再見。再見」broadcast push is TAPPED while the app is already open.
//
// Why this exists (not just Player's onEnded / ?ending=1):
// When the app is already open, the SW's notificationclick can't reliably
// deep-link via client.navigate("/play/10?ending=1") — navigating to the same
// path with only a new query string doesn't re-run React Router's
// useSearchParams, so Player never sees ?ending=1. Instead the SW postMessages
// { kind: "journey_complete" } to the open client; this gate listens for it
// and shows <JourneyComplete> as a top-level overlay, independent of the
// current route. (Cold start — app closed — still uses openWindow + ?ending=1.)

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { JourneyComplete } from "./JourneyComplete";

export function JourneyEndGate() {
  const nav = useNavigate();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof navigator === "undefined" || !navigator.serviceWorker) return;
    function onMessage(event: MessageEvent) {
      const data = event.data as { kind?: string };
      if (data?.kind === "journey_complete") setShow(true);
    }
    navigator.serviceWorker.addEventListener("message", onMessage);
    return () => {
      navigator.serviceWorker.removeEventListener("message", onMessage);
    };
  }, []);

  if (!show) return null;
  return (
    <JourneyComplete
      onDone={() => {
        setShow(false);
        nav("/");
      }}
    />
  );
}
